export default "__VITE_ASSET__4a062dc2__"